import type { FormInputType } from '@/components/UI/Form/types'

export default function getSessionUpdateFormInputs(): FormInputType[] {
  const formInputs: FormInputType[] = [
    {
      label: 'Reason for Updating',
      type: 'textarea',
      name: 'reason',
      required: true,
      placeholder:
        'Please indicate the reason you wish to update this session. This will be sent to any students who have registered via email.',
      size: 6,
    },
  ]

  return formInputs
}
